import { z } from 'zod'
import { FirestoreTimestamp } from './utils'

/**
 * OrganizationInvitation - Pending invitations for client users
 *
 * Collection path: organizationInvitations/{invitationId}
 */
export const OrganizationInvitation = z.object({
  invitationId: z.string(),
  organizationId: z.string(),
  organizationName: z.string(),
  serviceCompanyId: z.string(),

  // Invitation details
  email: z.string(),

  // Optional personalization for new users
  suggestedFirstName: z.string().optional(),
  suggestedLastName: z.string().optional(),

  // Status tracking
  status: z.enum(['pending', 'accepted', 'expired', 'cancelled']),
  token: z.string(), // Secure random token for acceptance

  // Audit
  invitedBy: z.string(), // Admin userId
  invitedAt: FirestoreTimestamp,
  expiresAt: FirestoreTimestamp, // 7 days default
  acceptedAt: FirestoreTimestamp.optional(),
  acceptedBy: z.string().optional(), // userId who accepted
})

export type OrganizationInvitation = z.infer<typeof OrganizationInvitation>
